/**
 * Where the pilot's drone cursor is, in screen pixels.
 *
 * Off-React on purpose (the same rule the studio's audioBus follows): this
 * updates every frame, and routing it through state would re-render the
 * whole page 60 times a second. The cursor writes, the swarm reads.
 *
 * `active` is only true while the earned drone cursor is actually flying,
 * so the swarm reacts to the drone, never to a plain mouse pointer.
 */
export const pointerBus = {
  x: 0,
  y: 0,
  active: false,
};
